enum OTPReferrer {
  singIn = 'sign_in',
  signUp = 'sign_up'
}

export { OTPReferrer };
